export default __webpack_public_path__ + "static/media/Events.3d224e44.svg";